import type { IRecord, IStatusSet } from '@platform/core/types';

/** Підсумок дочірніх записів (прототип chSummary): скільки всього, скільки закрито, сума «Залишилось (год)» і відсоток виконання. Чиста функція. */
export function childSummary(items: IRecord[], statuses: IStatusSet): { count: number; done: number; hours: number; percent: number } {
  const closed = new Set(statuses.list.filter((s) => s.closed).map((s) => s.value));
  const done = items.filter((r) => r.isClosed || closed.has(r.status)).length;
  const hours = items.reduce((n, r) => n + (Number(r.values['remaining']) || 0), 0);
  return { count: items.length, done, hours: Math.round(hours * 10) / 10, percent: items.length ? Math.round((done / items.length) * 100) : 0 };
}
